import { render, staticRenderFns } from "./Venduto.vue?vue&type=template&id=599ff7be&scoped=true"
import script from "./Venduto.vue?vue&type=script&lang=ts"
export * from "./Venduto.vue?vue&type=script&lang=ts"
import style0 from "./Venduto.vue?vue&type=style&index=0&id=599ff7be&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599ff7be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('599ff7be')) {
      api.createRecord('599ff7be', component.options)
    } else {
      api.reload('599ff7be', component.options)
    }
    module.hot.accept("./Venduto.vue?vue&type=template&id=599ff7be&scoped=true", function () {
      api.rerender('599ff7be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Venduto.vue"
export default component.exports